import { SocialCardVariant } from "~features/competitions/helpers";
import { ActiveCompetitionByTypeQuery } from "~graphql/typed-document-nodes";

export const getVariant = ({
  waitlistUserId,
  activeCompetition,
}: {
  waitlistUserId: string;
  activeCompetition: ActiveCompetitionByTypeQuery["activeCompetitionByType"];
}) => {
  const variant: SocialCardVariant =
    activeCompetition && waitlistUserId ? "competition" : "promoter";
  return variant;
};
